export const CLOUD_FRONT_URL = `${process.env.REACT_APP_CLOUD_FRONT_URL}`;
